var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92188 17.7389L7.22135 14.4395M8.87109 14.4395L12.1706 17.7389M8.04622 14.4395V18.5638",
    stroke: "#222222",
    strokeWidth: 1.2373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85156 9.79631C1.85156 8.0951 1.85156 7.2445 2.69716 6.71599C3.54275 6.1875 4.90372 6.1875 7.62565 6.1875H8.45052C11.1724 6.1875 12.5334 6.1875 13.379 6.71599C14.2246 7.2445 14.2246 8.0951 14.2246 9.79631V10.8274C14.2246 12.5286 14.2246 13.3792 13.379 13.9077C12.5334 14.4362 11.1724 14.4362 8.45052 14.4362H7.62565C4.90372 14.4362 3.54275 14.4362 2.69716 13.9077C1.85156 13.3792 1.85156 12.5286 1.85156 10.8274V9.79631Z",
    stroke: "#222222",
    strokeWidth: 1.2373
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2266 8.45889L14.3304 8.39661C16.0757 7.34931 16.9483 6.82568 17.6496 7.07851C18.3509 7.33135 18.3509 8.16957 18.3509 9.84607V10.7842C18.3509 12.4607 18.3509 13.2989 17.6496 13.5517C16.9483 13.8045 16.0757 13.2809 14.3304 12.2337L14.2266 12.1713",
    stroke: "#222222",
    strokeWidth: 1.2373,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5231 6.19076C11.662 6.19076 12.5853 5.26749 12.5853 4.12858C12.5853 2.98967 11.662 2.06641 10.5231 2.06641C9.3842 2.06641 8.46094 2.98967 8.46094 4.12858C8.46094 5.26749 9.3842 6.19076 10.5231 6.19076Z",
    stroke: "#222222",
    strokeWidth: 1.2373
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99023 6.18945C7.35692 6.18945 8.46484 5.08153 8.46484 3.71484C8.46484 2.34815 7.35692 1.24023 5.99023 1.24023C4.62355 1.24023 3.51562 2.34815 3.51562 3.71484C3.51562 5.08153 4.62355 6.18945 5.99023 6.18945Z",
    stroke: "#222222",
    strokeWidth: 1.2373
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d9516ba9b72eb451e702a3d1e5196286.svg";
export { ForwardRef as ReactComponent };